import { render, staticRenderFns } from "./docFieldValueManage.vue?vue&type=template&id=74c3765b&scoped=true"
import script from "./docFieldValueManage.vue?vue&type=script&lang=js"
export * from "./docFieldValueManage.vue?vue&type=script&lang=js"
import style0 from "./docFieldValueManage.vue?vue&type=style&index=0&id=74c3765b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c3765b",
  null
  
)

export default component.exports